<template>
  <div>
    <h2 style="margin-bottom: 16px">通道域名管理</h2>
    <div style="display: flex; align-items: center; margin-bottom: 16px">
      <a-input
        v-model:value="domainInput"
        placeholder="输入域名，如：example.com"
        style="width: 220px; margin-right: 8px"
      />
      <a-button type="primary" @click="addDomain">添加域名</a-button>
    </div>
    <x-table
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      rowKey="id"
      bordered
    >
      <template #action="{ record }">
        <a @click="deleteDomain(record)">删除</a>
      </template>
    </x-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { message, Modal } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import {
  channelDomainList,
  channelDomainCreate,
  channelDomainDel,
} from "@/api/api";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const domainInput = ref("");
const tableData = ref([]);
const loading = ref(false);
const props = defineProps({
  isRefresh: {
    type: Boolean,
    default: false,
  },
});
const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 80 },
  { title: "域名", dataIndex: "hostName", key: "hostName" },
  {
    title: "添加时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  { title: "操作", dataIndex: "action", key: "action", width: 100 },
];

watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);

const fetchTableData = async () => {
  loading.value = true;
  try {
    const res = await channelDomainList({});
    tableData.value = res.data.records || [];
  } catch (e) {
    message.error("获取域名列表失败");
  } finally {
    loading.value = false;
  }
};

const addDomain = async () => {
  if (!domainInput.value) {
    message.warning("请输入域名");
    return;
  }
  const params = {
    url: domainInput.value, // 可选，或补充输入
  };
  const res = await channelDomainCreate(params);
  if (res.code === "200") {
    message.success("添加成功");
    domainInput.value = "";
    fetchTableData();
  } else {
    message.error(res.msg);
  }
};

const deleteDomain = (record: any) => {
  Modal.confirm({
    title: "确认删除该域名？",
    content: `域名：${record.hostName}`,
    okText: "确定",
    cancelText: "取消",
    onOk: async () => {
      const params = { id: record.id };
      const res = await channelDomainDel(params);
      if (res.code === "200") {
        message.success("删除成功");
        fetchTableData();
      } else {
        message.error(res.msg);
      }
    },
  });
};

onMounted(() => {
  fetchTableData();
});
</script>

<style scoped></style>
